module.exports = __webpack_public_path__ + "files/9c6ca43afed497c681d18708a15854c2.svg";